import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import AdtfDeviceOverviewContextProvider from "./context/AdtfDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ADTF_MATRIX_ROUTE} from "../../util/RouteConstants";
import {ADTF_MATRIX} from "../../util/Constants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AdtfMatrixPage extends Component {
    render() {
        return (
            <Column>
                <AdtfDeviceOverviewContextProvider data={{assetSubtype: ADTF_MATRIX}}>
                    <TabLayout routes={ADTF_MATRIX_ROUTE} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={ADTF_MATRIX_ROUTE}/>
                </AdtfDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AdtfMatrixPage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/AdtfMatrixPage.js